(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["see-all-review"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.see-all-review__link');
    if (!trigger) return;

    const target = document.querySelector('.jdgm-content');
    // No reviews widget on this page: fall back to the link's href.
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
